import { Box } from '@mui/material'
import ErrorTrackerNav from './ErrorTrackerNav'
import ErrorTrackerRoutes from './ErrorTrackerRoutes'

const ErrorTrackerLayout = () => {
  return (
    <>
      <ErrorTrackerNav />
      <Box sx={{ px: 3 }}>
        <ErrorTrackerRoutes />
      </Box>
    </>
  )
}

export default ErrorTrackerLayout
